import PhoneArea from "components/PhonePreview/PhoneArea"
import React from "react"

const Preview = ({ bgImage, questions = [], menu_bg_color, label }) => {
  return (
    <PhoneArea>
      <div
        style={{
          backgroundImage: `url(${bgImage})`,
          width: "105%",
          height: "105%",
          backgroundSize: "cover",
          marginLeft: "-5px",
          backgroundPosition: "center center",
          boxShadow: "inset 0 0 0 500px rgb(0 0 0 / 50%)",
        }}
      >
        <div
          className="col-auto py-1 px-1 mb-3"
          style={{
            width: "90%",
            height: "80px",
            display: "flex",
            margin: "0 auto",
            flexDirection: "column",
            justifyContent: "space-between",
            borderBottom: "1px solid white",
          }}
        >
          <i
            className="bx bx-x font-size-24"
            style={{ cursor: "pointer", color: "gray", marginLeft: "-10px" }}
          />
          <p
            style={{
              textAlign: "center",
              color: "white",
              fontSize: "12px",
              margin: "0px",
            }}
          >
            {label}
          </p>
          <p
            style={{
              color: "white",
              fontSize: "12px",
              margin: "0px",
            }}
          >
            Question 1
          </p>
        </div>
        {questions[0] && (
          <>
            <p className="ms-3" style={{ color: "white" }}>
              <b>{questions[0]?.question}</b>
            </p>
            {questions[0]?.answers &&
              questions[0]?.answers?.map(
                (answer, index) =>
                  answer?.answer && (
                    <p
                      key={index}
                      className="mx-3"
                      style={{ margin: "0px", color: "white" }}
                    >
                      <i
                        className="bx bx-credit-card-front me-2"
                        style={{
                          color: "lightgrey",
                          cursor: "pointer",
                          verticalAlign: "middle",
                        }}
                      />
                      {answer?.answer}
                    </p>
                  )
              )}
          </>
        )}
        <div
          style={{
            width: "60px",
            height: "25px",
            backgroundColor: menu_bg_color,
            margin: "2em auto",
            borderRadius: "10px",
            color: "white",
            textAlign: "center",
            cursor: "pointer",
          }}
        >
          <span style={{ verticalAlign: "sub" }}>SUBMIT</span>
        </div>
      </div>
    </PhoneArea>
  )
}

export default Preview
